import {AnalysisGraphQL} from 'analysis-tool/AnalysisTypes';
import {GetAnalysisPipelineStep} from 'analysis-tool/AnalysisTypes';
import {assert} from 'Asserts';

import {PipelineStep} from './PipelineTypes';

export function getLegacyStepFromAnalysis(
  analysis: AnalysisGraphQL,
  step: PipelineStep
): GetAnalysisPipelineStep {
  const legacyStep = analysis.execution.steps.find(({id}) => step.id === id);
  assert(
    legacyStep != null,
    'Expected every node in analysis.steps to correspond to a step in analysis.execution.steps'
  );
  return legacyStep;
}
